/**
 * Default node size for graph components (diameter in pixels)
 */
export const DEFAULT_NODE_SIZE = 50

/**
 * Default zoom threshold for showing edge labels
 */
export const DEFAULT_ZOOM_THRESHOLD = 0.5

/**
 * Default edge colors for different states (Ant Design neutral palette)
 */
export const EDGE_COLORS = {
    default: "#8c8c8c", // neutral7
    selected: "#102244", // brand color
    disabled: "#d9d9d9", // neutral5
    disabledOpacity: 0.45,
    readonlyOpacity: 0.1
} as const

/**
 * Default background color for the graph canvas
 */
export const GRAPH_BACKGROUND_COLOR = "#f5f5f5"

/**
 * Maximum zoom level for automatic fitView (prevents over-zoom on small graphs)
 */
export const FIT_VIEW_MAX_ZOOM = 1
